module.exports = __webpack_public_path__ + "static/media/48360485_2308813862527125_6094215652770316288_o.5034f31f.jpg";